import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axios';
import { getAllFeedbackStudents, getAllVivaStatusStudents, getAllAnnouncementStudents, getAllVivaScheduleStudents, getAllSessionStudents } from "../../services/mailService";
import "./MailComm.css";

const templates = {
  feedback: {
    subject: "Feedback is shared in the portal",
    body: "Dear Students,\n\nYour Feedback for Thesis is now available in the portal.\n",
  },
  vivaStatus: {
    
    REPORT_REVISION_REQUIRED: {
      subject: "Course of Action on Thesis Submission",
      body: "Dear Students,\n\nThe deadline to your thesis resubmission is,\n\nDate: 2026-05-27.\n\nKindly submit your files to avoid dedcution of marks.\n",
    },
    WORK_IN_PROGRESS: {
      subject: "Course of Action on Thesis Submission",
      body: "Dear Students,\n\nYou are in your end term now.\n",
    },
    RESUBMISSION: {
      subject: "Course of Action on Thesis Submission",
      body: "Dear Students,\n\nhe deadline to your thesis resubmission is,\n\nDate: 2026-05-27.\n\nKindly submit your files to avoid deduction of marks.\n",
    },
    PHASE_COMPLETED: {
      subject: "Course of Action on Thesis Submission",
      body: "Dear Students,\n\nCongratulations on clearing your phase.\n",
    },
  },
  announcement: {
    
    notification: {
      subject: "Announcement",
      body: "Dear Students,\n\nThere is a new announcement regarding your next phase. Kindly check the portal.\n",
    },
    reminder: {
      subject: "Announcement",
      body: "Dear Students,\n\nThis is to remind you that the deadline for the announcement is tomorrow. Submit all your files before the deadline date.\n",
    }
  },
  vivaSchedule: {

    assigned:{
      subject: "Viva Schedule Notification",
      body: "Dear Students,\n\nYour Viva Slots has been assigned.\n\nKindly check the portal.\n",
    },
    reminder:{
      subject: "Viva Schedule Notification",
      body: "Dear Students,\n\nThis is a reminder that your viva is scheduled today.\n\nDate: 2026-05-18\n\nTime: 16:00 - 16:30\n\nPlease join at least 15 minutes early.\n",
    },
  },
  session: {
    subject: "Session Update",
    body: "Dear Students,\n\nPlease find the details regarding your upcoming session below.\n",
  },
};

export function MailComm() {
  const [type, setType] = useState("");
  const [batch, setBatch] = useState([]);
  const [reportType, setReportType] = useState("");
  const [feedbackStatus, setFeedbackStatus] = useState("");
  const [vivaIndiStatus, setVivaIndiStatus] = useState("");
  const [announcementType, setAnnouncementType] = useState("");
  const [vivaScheduleStatus, setVivaScheduleStatus] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("Write your mail here");

  const [feedbackStudents,setFeedbackStudents] = useState([]);
  const [vivaStatusStudents,setVivaStatusStudents] = useState([]);
  const [announcementStudents,setAnnouncementStudents] = useState([]);
  const [vivaScheduleStudents,setVivaScheduleStudents] = useState([]);
  const [sessionStudents, setSessionStudents] = useState([]);

  const [programs, setPrograms] = useState([]);
  const [programId, setProgramId] = useState("");

  const [selectedInstructorEmails, setSelectedInstructorEmails] = useState([]);

  const [allInstructors, setAllInstructors] = useState([]);
  const [selectedDirectExaminers, setSelectedDirectExaminers] = useState([]);

  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axiosInstance.get("/getAllPrograms")
      .then((res) => setPrograms(res.data?.data || []))
      .catch((err) => console.error("Error fetching programs:", err));

    axiosInstance.get("/instructors")
      .then((res) => setAllInstructors(res.data?.data || []))
      .catch((err) => console.error("Error fetching instructors:", err));
  }, []);


  const fetchFeedbackStudents = async () => {
    try {
      const data = await getAllFeedbackStudents(
        "feedback",
        feedbackStatus,
        batch,
        reportType
      );

      setFeedbackStudents(data.data || []);
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => {
    if (
      type === "feedback" &&
      feedbackStatus &&
      batch &&
      reportType
    ) {
      fetchFeedbackStudents();
    }
  }, [type, feedbackStatus, batch, reportType]);

  const fetchVivaStatusStudents = async () => {
    try {
      const data = await getAllVivaStatusStudents(
        "vivaStatus",
        vivaIndiStatus,
        batch,
        reportType
      );

      setVivaStatusStudents(data.data || []);
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => {
    if (
      type === "vivaStatus" &&
      vivaIndiStatus &&
      batch &&
      reportType
    ) {
      fetchVivaStatusStudents();
    }
  }, [type, vivaIndiStatus, batch, reportType]);

  const fetchAnnouncementStudents = async () => {
    try {
      const data = await getAllAnnouncementStudents(
        "announcement",
        batch,
        reportType
      );

      setAnnouncementStudents(data.data || []);
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => {
    if (
      type === "announcement" &&
      batch &&
      reportType
    ) {
      fetchAnnouncementStudents();
    }
  }, [type, batch, reportType]);

  const fetchVivaScheduleStudents = async () => {
    try {
      const data = await getAllVivaScheduleStudents(
        "vivaSchedule",
        batch,
        reportType
      );

      setVivaScheduleStudents(data.data || []);
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => {
    if (
      type === "vivaSchedule" &&
      batch &&
      reportType
    ) {
      fetchVivaScheduleStudents();
    }
  }, [type, batch, reportType]);

  const fetchSessionStudents = async () => {
    try {
      const data = await getAllSessionStudents(
        "session",
        batch,
        programId || undefined
      );

      setSessionStudents(data.data || []);
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => {
    if (
      type === "session" &&
      batch.length > 0
    ) {
      fetchSessionStudents();
    }
  }, [type, batch, programId]);

  const studentsList =
  type === "feedback"
    ? feedbackStudents
    : type === "vivaStatus"
    ? vivaStatusStudents
    : type === "announcement"
    ? announcementStudents
    : type === "session"
    ? sessionStudents
    : vivaScheduleStudents;

  useEffect(() => {
  if (type === "feedback") {
    const template = templates.feedback;
    if (template) {
      setSubject(template.subject);
      setBody(template.body);
    }
  }
}, [type]);

  useEffect(() => {
    if (type === "vivaStatus" && vivaIndiStatus) {
      const template = templates.vivaStatus?.[vivaIndiStatus];
      if (template) {
        setSubject(template.subject);
        setBody(template.body);
      }
    }
  }, [type, vivaIndiStatus]);

  useEffect(() => {
    if (type === "announcement" && announcementType) {
      const template = templates.announcement?.[announcementType];
      if (template) {
        setSubject(template.subject);
        setBody(template.body);
      }
    }
  }, [type, announcementType]);

  useEffect(() => {
    if (type === "vivaSchedule" && vivaScheduleStatus) {
      const template = templates.vivaSchedule?.[vivaScheduleStatus];
      if (template) {
        setSubject(template.subject);
        setBody(template.body);
      }
    }
  }, [type, vivaScheduleStatus]);

  useEffect(() => {
    if (type === "session") {
      const template = templates.session;
      if (template) {
        setSubject(template.subject);
        setBody(template.body);
      }
    }
  }, [type]);

  const handleStudentsChange = (e) => {
    const values = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );

    const studentEmails =
      values.includes("all")
        ? studentsList.map((s) => s.email)
        : values;

    setSelectedStudents(studentEmails);

    const instructorMap = new Map();

    studentsList
      .filter((student) => studentEmails.includes(student.email))
      .forEach((student) => {
        [
          {
            name: student.examiner1Name,
            email: student.examiner1Email,
          },
          {
            name: student.examiner2Name,
            email: student.examiner2Email,
          },
          {
            name: student.reviewer1Name,
            email: student.reviewer1Email,
          },
          {
            name: student.reviewer2Name,
            email: student.reviewer2Email,
          },
        ].forEach((inst) => {
          if (inst.email) {
            instructorMap.set(inst.email, inst);
          }
        });
      });

    setSelectedInstructorEmails([...instructorMap.values()]);
  };

  const removeStudent = (email) => {
    const updatedStudents = selectedStudents.filter(
      (item) => item !== email
    );

    setSelectedStudents(updatedStudents);

    const instructorMap = new Map();

    studentsList
      .filter((student) => updatedStudents.includes(student.email))
      .forEach((student) => {
        [
          {
            name: student.examiner1Name,
            email: student.examiner1Email,
          },
          {
            name: student.examiner2Name,
            email: student.examiner2Email,
          },
          {
            name: student.reviewer1Name,
            email: student.reviewer1Email,
          },
          {
            name: student.reviewer2Name,
            email: student.reviewer2Email,
          },
        ].forEach((inst) => {
          if (inst.email) {
            instructorMap.set(inst.email, inst);
          }
        });
      });

    setSelectedInstructorEmails([...instructorMap.values()]);
  };

  const handleDirectExaminersChange = (e) => {
    const values = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );

    const instructors = allInstructors.filter((i) => values.includes(i.email));
    setSelectedDirectExaminers(instructors);
  };

  const removeDirectExaminer = (email) => {
    setSelectedDirectExaminers((prev) =>
      prev.filter((i) => i.email !== email)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSending(true);

      const recipients = [
        ...new Set([
          ...selectedStudents,
          ...selectedInstructorEmails.map((i) => i.email),
          ...selectedDirectExaminers.map((i) => i.email),
        ]),
      ];

      const payload = {
        recipients,
        subject,
        body,
      };

      await axiosInstance.post("/send-mail", payload,{showToastOnResponse: true});
      setType("");
      setReportType("");
      setBatch([]);
      setBody("write your mail here");
      setSubject("");
      setSelectedStudents([]);
      setSelectedInstructorEmails([]);
      setSelectedDirectExaminers([]);

    } catch (err) {
        console.error(err);
      } finally {
        setSending(false);
      }
  };

  const getStudentLabel = (email) => {
    const student = studentsList.find((s) => s.email === email);
    return student
      ? `${student.name}, ${student.email}`
      : email;
  };

  const allSelected = (selectedStudents.length === studentsList.length) && selectedStudents.length !== 0 ;

  return (
    <div className="mail-page">
      <div className="mail-card">
        <div className="top-row">
          <div className="formInput">
            <label>Mail Type </label>
            <select value={type} onChange={(e) => setType(e.target.value)}>
              <option value="">-- Select Mail Type --</option>
              <option value="feedback">Feedback</option>
              <option value="vivaStatus">Viva Status</option>
              <option value="announcement">Announcement</option>
              <option value="vivaSchedule">Viva Schedule</option>
              <option value="session">Session</option>
            </select>
          </div>

          <div className="formInput">
            <label>Batch </label>
            <select
                multiple
                value={batch}
                onChange={(e) =>
                    setBatch(
                        Array.from(
                            e.target.selectedOptions,
                            option => option.value
                        )
                    )
                }
            >
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
            </select>
          </div>

          {type !== "session" && (
          <div className="formInput">
            <label>Report Type </label>
            <select value={reportType} onChange={(e) => setReportType(e.target.value)}>
              <option value="">-- Select Report Type --</option>
              <option value="ProjectProposal">Project Proposal</option>
              <option value="Phase1">Phase 1</option>
              <option value="Phase2">Phase 2</option>
              <option value="Phase3">Phase 3</option>
            </select>
          </div>
          )}

          {type === "session" && (
          <div className="formInput">
            <label>Programme Name </label>
            <select value={programId} onChange={(e) => setProgramId(e.target.value)}>
              <option value="">-- All Programmes --</option>
              {programs.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.programName} ({p.degreeName})
                </option>
              ))}
            </select>
          </div>
          )}

          {type === "feedback" && (
            <>
                <select value={feedbackStatus} onChange={(e) => setFeedbackStatus(e.target.value)}>
                <option value="">-- Select Feedback Status --</option>
                <option value="Shared">Feedback Shared</option>
                <option value="Not Shared">Feedback Not Shared</option>
                </select>
            </>
            )}

          {type === "vivaStatus" && (
            <>
                <select value={vivaIndiStatus} onChange={(e) => setVivaIndiStatus(e.target.value)}>
                <option value="">-- Select Viva Status --</option>
                <option value="REPORT_REVISION_REQUIRED">Revised Report</option>
                <option value="WORK_IN_PROGRESS">End Term</option>
                <option value="RESUBMISSION">End Term Resubmission</option>
                <option value="PHASE_COMPLETED">Phase Complete</option>
                </select>
            </>
            )}

            {type === "announcement" && (
            <>
                <select value={announcementType} onChange={(e) => setAnnouncementType(e.target.value)}>
                <option value="">-- Select Announcement Type --</option>
                <option value="notification">Notification</option>
                <option value="reminder">Reminder</option>
                </select>
            </>
            )}

            {type === "vivaSchedule" && (
            <>
                <select value={vivaScheduleStatus} onChange={(e) => setVivaScheduleStatus(e.target.value)}>
                <option value="">-- Select Viva Schedule Notification --</option>
                <option value="assigned">Slots Assigned</option>
                <option value="reminder">Reminder</option>
                </select>
            </>
            )}

        </div>

      <div className="to-area">
        <div className="to-header">
          <span>To</span>
          <select
            name="students"
            multiple
            value={selectedStudents}
            onChange={handleStudentsChange}
            size={6}
          >
            <option value="all">-- Select All --</option>
            {studentsList.map((student) => (
                <option
                  key={student.name}
                  value={student.email}
                >
                  {student.name},
                  {student.email}
                </option>
              ))}
          </select>
        </div>

        <div className="chips-container">
          {selectedStudents.map((email) => (
            <div key={email} className="chip">
              <span>{getStudentLabel(email)}</span>
              <button
                type="button"
                className="chip-remove"
                onClick={() => removeStudent(email)}
              >
                ×
              </button>
            </div>
          ))}
        </div>

        <div className="chips-container">
          {selectedInstructorEmails.map((inst) => (
            <div key={inst.email} className="chip instructor-chip">
              <span>
                {inst.name}, {inst.email}
              </span>
            </div>
          ))}
        </div>

        {allSelected && (
          <div className="all-selected-note">All students selected</div>
        )}
      </div>

      <div className="to-area">
        <div className="to-header">
          <span>To (Examiners/Reviewers directly)</span>
          <select
            name="directExaminers"
            multiple
            value={selectedDirectExaminers.map((i) => i.email)}
            onChange={handleDirectExaminersChange}
            size={6}
          >
            {allInstructors.map((inst) => (
              <option key={inst.id} value={inst.email}>
                {inst.name}, {inst.email}
              </option>
            ))}
          </select>
        </div>

        <div className="chips-container">
          {selectedDirectExaminers.map((inst) => (
            <div key={inst.email} className="chip">
              <span>{inst.name}, {inst.email}</span>
              <button
                type="button"
                className="chip-remove"
                onClick={() => removeDirectExaminer(inst.email)}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>

        <input
          className="subject-input"
          type="text"
          placeholder="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />

        <textarea
          className="body-input"
          placeholder="Write your mail here"
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />

        <button
          className="send-btn"
          onClick={handleSubmit}
          disabled={sending || (selectedStudents.length === 0 && selectedDirectExaminers.length === 0)}
          style={{cursor:sending || (selectedStudents.length === 0 && selectedDirectExaminers.length === 0)?"not-allowed" :"pointer"}}
        >
          {sending ? "Sending..." : "Send"}
        </button>

      </div>
    </div>
  );
}
